import ModuleRegistry from 'react-module-container/dist/src/module-registry';
export var GET_MANDATORY_BI_FIELDS = 'businessManager.getMandatoryBIFields';
export var getMandatoryBIFields = function () {
    return ModuleRegistry.invoke(GET_MANDATORY_BI_FIELDS);
};
//# sourceMappingURL=mandatoryBIFields.js.map